import HomeStyles from './styles/Home.module.css'
import Navibar from './Navibar'
import React, { useState } from 'react'
import { Button, Col, Divider, Image, Popover, Row } from 'antd'
import ShowcaseFooter from './Footer'
import StoryEditForm from './StoryEditForm'
import BioEditForm from './BioEditForm'
import ProfilePhotoEditForm from './ProfilePhotoEditForm'
import ArtVideoEditForm from './ArtVideoEditForm'
import { getDefaultBio, getDefaultStory } from './test/data'

export default function AboutPage(props) {
  let name = props.artistName
  const [profileEditVisible, setProfileEditVisible] = useState(false)
  const [cvEditVisible, setCVEditVisible] = useState(false)
  const [bioEditVisible, setBioEditVisible] = useState(false)
  const [videoEditVisible, setVideoEditVisible] = useState(false)
  const [storyEditVisible, setStoryEditVisible] = useState(false)

  const profileImage = {
    src: props.profile?.avatar,
    alt: name
  }

  const bio = {
    title: props.bio?.title,
    body: props.bio.body || getDefaultBio()
  }

  const story = {
    title: props.story?.title,
    body: props.story?.body || getDefaultStory()
  }

  const getCVLayout = () => {
    const layout = []
    const capitalizeWords = (mySentence) => {
      if (!mySentence) return ''
      const words = mySentence.split(' ')

      for (let i = 0; i < words.length; i++) {
        words[i] = words[i][0].toUpperCase() + words[i].substr(1)
      }
      return words.join(' ')
    }
    const sanity_style = (styles) => {
      if (!styles) return ''
      styles = styles.replaceAll(';', ',')
      styles = styles.replaceAll('[', '').replaceAll(']', '').replaceAll("'", '')
      styles = styles.replaceAll(',', ' ')
      return capitalizeWords(styles).replaceAll(' ', ',')
    }
    const sanity_location = (city, state, country) => {
      if (city && state && country) return capitalizeWords(city) + ' , ' + state + ' , ' + country
      if (state && country) return state + ' , ' + country
      if (city && country) return capitalizeWords(city) + ' , ' + country
      if (city) return city
      if (state) return state
      if (country) return country
      return ''
    }
    const sanity_resume_url = (url) => {
      if (!url) return ''
      if (url.startsWith('/root/website')) {
        return url.replaceAll('/root/website/revart/revart/', 'https://revart.co/')
      }
      return url
    }

    if (props.art_style) {
      layout.push(
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            marginTop: 12,
            marginLeft: 12
          }}
        >
          <span>{sanity_style(props.art_style)} </span>
        </div>
      )
    }

    layout.push(
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          marginTop: 12,
          marginLeft: 12
        }}
      >
        <span>&nbsp;{sanity_location(props.city, props.state, props.country)}</span>
      </div>
    )

    if (props.resume_url && props.resume_url !== 'None') {
      layout.push(
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            marginTop: 6,
            marginLeft: 12
          }}
        >
          <a style={{ textDecoration: 'underline', marginLeft: 28, marginTop: 12 }} href={sanity_resume_url(props.resume_url)}>
            Download Resume
          </a>
        </div>
      )
    }

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 24,
          paddingBottom: 4
        }}
      >
        {layout}
      </div>
    )
  }

  const editLayout = (type) => {
    const getClickFunction = (type) => {
      if (type === 'story') {
        return () => {
          setStoryEditVisible(true)
        }
      }
      if (type === 'bio') {
        return () => {
          setBioEditVisible(true)
        }
      }
      if (type === 'profile') {
        return () => {
          setProfileEditVisible(true)
        }
      }
      if (type === 'cv') {
        return () => {
          setCVEditVisible(true)
        }
      }
      if (type === 'video') {
        return () => {
          setVideoEditVisible(true)
        }
      }
      return () => {}
    }
    return (
      <div style={{ padding: 12, marginBottom: 0 }}>
        <Button type={'primary'} onClick={getClickFunction(type)}>
          Edit
        </Button>
      </div>
    )
  }

  const onCancel = () => {
    setProfileEditVisible(false)
    setBioEditVisible(false)
    setStoryEditVisible(false)
    setVideoEditVisible(false)
    setCVEditVisible(false)
  }

  return (
    <div style={{ overflowX: 'hidden' }}>
      <Navibar {...props} />
      <main className={HomeStyles.main}>
        <ProfilePhotoEditForm
          toLoad={profileImage}
          email={props.email}
          visible={profileEditVisible}
          onSubmit={(data) => {
            setProfileEditVisible(false)
            if (props.onProfilePhotoSubmit) props.onProfilePhotoSubmit(data)
          }}
          onCancel={onCancel}
        />

        <BioEditForm
          toLoad={props.bioContent}
          visible={bioEditVisible}
          onSubmit={(data) => {
            setBioEditVisible(false)
            if (props.onBioSubmit) props.onBioSubmit(data)
          }}
          onCancel={onCancel}
        />

        <ArtVideoEditForm
          toLoad={props.profile?.video}
          visible={videoEditVisible}
          onSubmit={(url) => {
            setVideoEditVisible(false)
            if (props.onArtVideoSubmit) props.onArtVideoSubmit(url)
          }}
          onCancel={onCancel}
        />

        <StoryEditForm
          toLoad={props.storyContent}
          toLoadTitle={story.title}
          visible={storyEditVisible}
          onSubmit={(title, data) => {
            setStoryEditVisible(false)
            if (props.onStorySubmit) props.onStorySubmit(title, data)
          }}
          onCancel={onCancel}
        />
        <Row gutter={24} style={{ paddingLeft: '4rem', paddingRight: '4rem' }}>
          <Col xs={12}>
            <div
              style={{
                width: '100%',
                flexDirection: 'column',
                alignItems: 'center',
                display: 'flex',
                padding: 24
              }}
            >
              <h4
                style={{
                  fontSize: 28,
                  color: 'rgba(0,0,0,0.85)',
                  fontWeight: 400,
                  marginLeft: 'auto',
                  marginRight: 'auto'
                }}
              >
                About
              </h4>
            </div>
            <Popover content={editLayout('bio')}>
              <div
                style={{ width: '100%', flexDirection: 'column', alignItems: 'center', fontSize: 2 }}
                dangerouslySetInnerHTML={{ __html: bio.body }}
              ></div>
            </Popover>
            <Popover content={editLayout('cv')}>
              <div style={{ width: '100%', flexDirection: 'column', alignItems: 'flex-start' }}>{getCVLayout()}</div>
            </Popover>
          </Col>
          <Col xs={12}>
            <Popover content={editLayout('profile')}>
              <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Image preview={false} src={profileImage.src} alt={profileImage.alt} />
              </div>
            </Popover>
          </Col>
          {/*<Col xs={24}>*/}
          {/*    <div style={{*/}
          {/*        display: "flex", marginTop: 48,*/}
          {/*        flexDirection: "column", alignItems: "center", width: '100%'*/}
          {/*    }}>*/}
          {/*        {props.profile?.video && (*/}
          {/*            <Popover content={editLayout('video')}>*/}
          {/*                <ReactPlayer*/}
          {/*                    url={'https://www.youtube.com/watch?v=ysz5S6PUM-U'}*/}
          {/*                    playing={false}*/}
          {/*                />*/}
          {/*            </Popover>*/}
          {/*        )}*/}
          {/*        {!props.profile?.video && (*/}
          {/*            <Button type={'primary'} onClick={() => {*/}
          {/*                setVideoEditVisible(true)*/}
          {/*            }}>[Add Video (Optional)]</Button>*/}
          {/*        )}*/}
          {/*    </div>*/}
          {/*</Col>*/}
        </Row>
        <Divider />
        <div style={{ paddingLeft: '6rem', paddingRight: '6rem', paddingTop: '2rem' }}>
          {story.title && (
            <div
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: 24,
                paddingTop: 12
              }}
            >
              <h4 style={{ fontSize: 24, color: 'rgba(0, 0, 0, 0.87)' }}>{story.title}</h4>
            </div>
          )}
          <Popover content={editLayout('story')}>
            <div
              style={{ width: '100%', flexDirection: 'column', alignItems: 'center' }}
              dangerouslySetInnerHTML={{ __html: story.body }}
            ></div>
          </Popover>
        </div>
      </main>
      <ShowcaseFooter />
    </div>
  )
}
